<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OLnFWj/tc-custom/9781612434797.jpg?1740430311923" alt="This image is the cover for the book Homemade Smoothies for Mother and Baby"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Homemade Smoothies for Mother and Baby
      </h1>
      <p class="bookDescription body article font2">
        <p>SUPERDELICIOUS AND ULTRANUTRITIOUS, SMOOTHIES ARE THE PERFECT FOOD FOR MOM AND HER LITTLE ONEEvery mother-to-be knows how important it is to eat right. But it’s challenging to consume the nutrients you need during the different phases of pregnancy and motherhood. Luckily, Homemade Smoothies for Mother and Baby makes it easy for you to optimize your health with tasty, all-natural smoothies. It includes 200 recipes packed with vitamins, minerals and other vital nutrients that address you and your baby’s every need. •Enhance fertility with Pineapple Pizzazz•Ease morning sickness with Honeydew Healer•Increase iron intake with Goji Gold•Rejuvenate skin with Beaming Beets•Relieve cramps with Raspberry Relaxer•Boost your mood with Cheerful Cherry•De-stress with Peaceful Papaya•Optimize breast milk production with Motherly Mango Offering information on food allergies and intolerances, Homemade Smoothies for Mother and Baby also features tips for transitioning babies from breast milk to solid foods as well as tricks to disguise healthy greens for toddlers and children.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kristine Miles
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ulysses Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5828a0c9